import React from 'react';
// import Div from '../Div';
import './spacing.css';

export default function Spacing({ lg, md }) {
  return <div className={`cs-height_${lg} cs-height_lg_${md}`}></div>;
}